import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProducts } from 'services/products/products.service';
import randomizeList from 'utils/randomizeList';

import { ImageTypeNameEnum, ItemTypeEnum } from '@inter-ikea-kompis/enums';
import type { IShoppingProduct } from '@inter-ikea-kompis/types/lib';

import { productAction } from './products.store';
import { getVpcForSpr, shoppingProducts2NormalizedTypes } from './products.utils';

import type { IThunkApi } from 'redux-store/store';
import type { IShoppingProductsMap } from 'utils/constants';

export const fetchProductsData = createAsyncThunk<IShoppingProductsMap, undefined, IThunkApi>(
  'products/setProducts',
  async (_, { dispatch }) => {
    const productData = await getProducts();
    dispatch(productAction.setProducts(productData));

    const allValidSPRs = Object.values(productData).filter((item) => {
      const { valid, content } = item.product;

      const isSpr = content?.itemType === ItemTypeEnum.spr;

      const hasContextProductPicture = !!content?.image?.find((img) => {
        return img.typeName === ImageTypeNameEnum.contextProductPicture;
      });

      const vpcCode = getVpcForSpr(item.product);

      return valid && isSpr && hasContextProductPicture && vpcCode;
    });

    const sortedSPRs = randomizeList(allValidSPRs);

    dispatch(productAction.setAllValidSPRs(sortedSPRs));

    return productData;
  },
);

export const handleVisibleProducts = createAsyncThunk<void, IShoppingProduct[], IThunkApi>(
  'products/setVisibleProducts',
  async (visibleProducts, { dispatch }) => {
    const toTypes = shoppingProducts2NormalizedTypes(visibleProducts);

    dispatch(productAction.setVisibleProducts(toTypes));
  },
);
